// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "../css/" + {"vendors-node_modules_atlas_ui_build_styles_css":"0837b0e3e579baaca1ee","src_modules_share-css_js":"9ea025faebfe748d59fc","StorePage":"d39448fa2b396b265f79"}[chunkId] + "/index.css";
};